import { mergeBaseUrlWithEndpoints } from "@dashboard/library";
import { AUTH_API_URL } from "./environment.constants";

const aircallAuthApiUrls = {
  USERS_SIGNIN: "/auth/v1/users/session",
  USERS_SIGNIN_MFA: "/auth/v2/users/session",
  USERS_SIGNIN_VALIDATE_CODE: "/auth/v2/users/sessions/code",
  USERS_ACCEPT_INVITATION: "/auth/v1/users/invitation/accept",
  USERS_ACCEPT_INVITATION_V2: "/auth/v2/users/invitation/accept",
  GOOGLE_SIGNIN: "/auth/v1/users/sessions/idp/google",
  COGNITO_TOKEN: "/auth/v0/tokens",
  REFRESH_TOKEN: "/auth/v1/tokens/refresh",
  NON_MIGRATED_REFRESH_TOKEN: "/auth/v0/tokens/refresh",
  SAML_IDP: "/auth/v1/users/sessions/saml",
  SAML_CODE: "/auth/v1/users/sessions/idp/saml/code",
  SAML_FILE_UPLOAD: "/auth/v1/companies/:id/saml/configuration",
};

export const AIRCALL_AUTH_API_ENDPOINTS = mergeBaseUrlWithEndpoints<
  typeof aircallAuthApiUrls
>(AUTH_API_URL, aircallAuthApiUrls);
